import { isProvisionalIdentifier, formatCurrency, isDateObject, uuidv4 } from '../util';

class PartialClaim {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.eventId = data.eventId || null;
    this.staffUserId = data.staffUserId || null;
    this.primaryClaim = data.primaryClaim || null;
    this.secondaryClaims = data.secondaryClaims || [];
    this.positionClaimDate = data.positionClaimDate || null;
    this.positionActualStart = data.positionActualStart || null;
    this.positionActualEnd = data.positionActualEnd || null;
    this.positionMealBreakStart = data.positionMealBreakStart || null;
    this.positionMealBreakEnd = data.positionMealBreakEnd || null;
    this.positionRestBreaksStart = data.positionRestBreaksStart || {};
    this.positionRestBreaksEnd = data.positionRestBreaksEnd || {};
    this.positionMealBreakAcknowledgement = data.positionMealBreakAcknowledgement || {};
    this.positionRestBreakAcknowledgement = data.positionRestBreakAcknowledgement || {};
    this.positionShiftSegmentId = data.positionShiftSegmentId || null;
  }
}

export default PartialClaim;
